/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2022-12-09 14:02:27
 * @Description: 
 */
import React, { memo } from "react";
import { openAppOrToDeeplink } from "src/utils";
import FTLang from "src/utils/FTLang";
import styles from "./BtnOpenApp.module.scss";

const BtnOpenApp = (props: any): JSX.Element => {
  function clickHandle() {
    openAppOrToDeeplink("homepage_nav_button");
  }

  return (
    <button
      id="btn_navigation_open_in_app"
      className={styles.btn}
      onClick={() => clickHandle()}
    >
      {FTLang._("goart_mobile_traffic_nav_button")}
    </button>
  );
};

export default BtnOpenApp;
